import styled from "styled-components";

interface IPopUpContainerProps {
  bgColor?: string;
  isDirectChild?: boolean;
  position?: string;
}

export const PopUpContainer = styled.div<IPopUpContainerProps>`
  @keyframes deployPopUp {
    0% {
      opacity: 0%;
      filter: blur(0.2rem);
    }

    100% {
      opacity: 100%;
      filter: blur(0);
    }
  }

  position: ${({ position }) => {
    if (position) {
      return position;
    }

    return "fixed";
  }};
  z-index: 1100 !important;

  left: 0;
  top: 0;
  width: calc(100%);
  height: calc(100%);
  overflow: hidden;
  transition: all 0.25s linear 0s;
  opacity: 0%;
  margin-left: 0 !important;
  margin: 0 !important;
  background-color: ${({ bgColor }) => {
    if (bgColor) {
      return bgColor;
    }

    return "transparent";
  }};
  filter: blur(0.2rem);
  overflow-y: hidden;

  display: flex;
  flex-direction: column;

  &#popUpviewDeliveryNotePopUp {
    padding-bottom: 0;
  }

  &.show {
    opacity: 100%;
    filter: blur(0);
    animation: deployPopUp 0.25s linear 1;
  }

  & > * {
    margin: auto;
    margin-left: ${({ isDirectChild }) => {
      if (isDirectChild) {
        return "-1rem";
      }

      return "auto";
    }};
    margin-top: ${({ isDirectChild }) => {
      if (isDirectChild) {
        return "-1rem";
      }

      return "auto";
    }};
    margin-right: auto;
  }

  & .scrollable {
    height: 100%;
    width: 100%;
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    z-index: 9000;

    & > .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      opacity: 30%;
      filter: blur(0.2rem);
      transition: all 0.25s linear 0s;

      z-index: -1;
    }

    & > span {
      position: relative;
      z-index: 10000;
    }

    & > * {
      margin: auto;
    }
  }
`;

export const PopUpBg = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 30%;
  filter: blur(0.2rem);
  transition: all 0.25s linear 0s;

  z-index: -10;
`;
